import { api } from "./urlApi";

export const getEquiposActivos = async () => {
  const url = `${api}/equipos/get.php?active=true`;

  try {
    const resp = await fetch(url);
    const equipos = await resp.json();

    return equipos;
  } catch (error) {
    console.error("Error: ", error);
    return false;
  }
};

export const getEquiposInactivos = async () => {
  const url = `${api}/equipos/get.php`;

  try {
    const resp = await fetch(url);
    const equipos = await resp.json();

    return equipos;
  } catch (error) {
    console.error("Error: ", error);
    return false;
  }
};

export const getEquipoById = async (id) => {
  const url = `${api}/equipos/getById.php?id=${id}`;

  try {
    const resp = await fetch(url);
    const equipo = await resp.json();

    return equipo;
  } catch (error) {
    console.error("Error: ", error);
    return false;
  }
};

//PUT

export const addEquipo = async (equipo) => {
  const url = `${api}/equipos/addEquipo.php`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify(equipo),
    });

    return resp;
  } catch (error) {
    console.error("Error: ", error);
    return false;
  }
};

export const updateEquipo = async (equipo) => {
  const url = `${api}/equipos/updateEquipo.php`;
  try {
    const resp = await fetch(url, {
      method: "PUT",
      body: JSON.stringify(equipo),
    });

    return resp;
  } catch (error) {
    console.error("Error: ", error);
    return false;
  }
};

export const finalizarEquipo = async (equipo) => {
  const url = `${api}/equipos/finalizarEquipo.php`;
  try {
    const resp = await fetch(url, {
      method: "PUT",
      body: JSON.stringify(equipo),
    });

    return resp;
  } catch (error) {
    console.error("Error: ", error);
    return false;
  }
};
